export default __webpack_public_path__ + "static/media/6-WashDay.bd61f1e0.jpeg";